<template>
  <div id="clear">
    <div class="wrap">
      <div class="bg"><img :src="`${publicPath}img/common/clear_blink.gif`"></div>
      <div class="mainImg"><img :src="`${publicPath}img/${chara}/clear_img.png`"></div>
      <div class="shareTit"><p>結果をシェアしてクリア特典をゲット！</p></div>
      <div class="sns">
        <ul>
          <li><a :href="share_TW" rel="nofollow" target="_blank" @click="onClickShare"><img :src="`${publicPath}img/common/sns_tw.png`" alt="Twitter"></a></li>
          <li><a :href="share_FB" rel="nofollow" target="_blank"><img :src="`${publicPath}img/common/sns_fb.png`" alt="Facebook" @click="onClickShare"></a></li>
          <li><a :href="share_LINE" rel="nofollow" target="_blank" @click="onClickShare"><img :src="`${publicPath}img/common/sns_line.png`" alt="LINE"></a></li>
        </ul>
      </div>
      <div class="btn">
        <div class="frame-outer" :style="frameStyle">
          <div class="inr" @click="onClickGetBtn">クリア特典をゲットする</div>
          <div class="arrow gray" :style="arrowStyle"></div>
        </div>
        <div class="frame-outer" :style="frameBlue">
          <div class="inr" @click="onClickTop">トップへ</div>
          <div class="arrow white" :style="arrowWhite"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'

  export default {
    name: 'Result_Clear',
    props: {
      chara: String,
    },
    data() {
      return {
        publicPath: process.env.BASE_URL,
        shareObj: {},
        frameStyle: {},
        arrowStyle: {},
        frameGray: {
          backgroundImage: 'url(./img/common/gray_frm02_522_t.png),url(./img/common/gray_frm02_522_b.png), url(./img/common/gray_frm02_l.png), url(./img/common/gray_frm02_r.png)'
        },
        framePink: {
          backgroundImage: 'url(./img/common/pink_frm02_522_t.png),url(./img/common/pink_frm02_522_b.png), url(./img/common/pink_frm02_l.png), url(./img/common/pink_frm02_r.png)'
        },
        frameBlue: {
          backgroundImage: 'url(./img/common/blue_frm02_522_t.png),url(./img/common/blue_frm02_522_b.png), url(./img/common/blue_frm02_l.png), url(./img/common/blue_frm02_r.png)'
        },
        arrowGray: {
          backgroundImage: 'url(./img/common/gray_arw.png)'
        },
        arrowWhite: {
          backgroundImage: 'url(./img/common/white_arw.png)'
        },
        share: false,
        timer: null,

        share_FB: null,
        share_LINE: null,
        share_TW: null,

        charaObj: {
          shirogane: {name: '白銀御行', text: '初級 白銀'},
          iino:      {name: '伊井野ミコ', text: '初級 伊井野'},
          kaguya:    {name: '四宮かぐや', text: '中級 かぐや'},
          ishigami:  {name: '石上優', text: '中級 石上'},
          tsubame:   {name: '子安つばめ', text: '上級 つばめ'},
          hayasaka:  {name: '早坂愛', text: '上級 早坂'},
          fujiwara:  {name: '藤原千花', text: '難題美女？ 藤原'},
          shijo:     {name: '四条眞妃', text: '四条'}
        }
      }
    },
    mounted() {
      this.shareObj = this.$parent.$parent.storageData.share
      // console.log(this.shareObj)

      this.share = this.shareObj[this.chara]
      if(this.share){
        this.frameStyle = this.framePink
        this.arrowStyle = this.arrowPink
        _$('#clear .arrow').removeClass('gray').addClass('white')
      } else {
        this.frameStyle = this.frameGray
        this.arrowStyle = this.arrowGray
      }
      this.blinkArrow()

      let shareURL = 'https://youngjump.jp/kaguyasama/zunougame/chara/' + this.chara + '/',
          charaName = this.charaObj[this.chara].name,
          charaText = this.charaObj[this.chara].text,
          tweetVal = charaText + '編を完膚なきまでに攻略しました！\n\n'

      if(this.chara === 'shijo'){
        tweetVal = '四条編を特に何の努力もなく攻略しました！\n\n'
      }

      tweetVal += '『 #かぐや様は告らせたい 』への愛が試される #天才たちとの恋愛頭脳GAME 公開中！\n君は天才たちに告らせられるか！？\nゲームをクリアして、限定ドット絵壁紙をGET！\n'
                + '#' + charaName

      this.share_FB = 'http://www.facebook.com/share.php?u=' + shareURL
      this.share_LINE = 'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(shareURL)
      this.share_TW = 'https://twitter.com/share?url=https://youngjump.jp/kaguyasama/zunougame/&text=' + encodeURIComponent(tweetVal)
    },
    destroyed() {
      this.stopTimer()
    },
    watch: {
      share(newValue) {
        if(newValue){
          this.frameStyle = this.framePink
          this.arrowStyle = this.arrowWhite
          _$('#clear .arrow').removeClass('gray').addClass('white')
          _$('#clear .white').show()
        }
      }
    },
    methods: {
      onClickShare(){
        this.share = true
        this.shareObj[this.chara] = true
        this.$parent.$parent.storageData.share = this.shareObj
        this.$parent.$parent.setLocalStorage()
      },
      onClickGetBtn(){
        if(this.share){
          let url = './wallpaper/zunougame_' + this.chara + '.png'
          window.open(url)
        }
      },
      onClickTop(){
          this.$emit('allClear', 'top');
      },
      blinkArrow: function(){
        this.timer = setInterval(function(){
          _$('#clear .white').toggle()
        }.bind(this), 500)
      },
      stopTimer: function(){
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #clear {
    background: #000;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .wrap {
      width: toVW(662);
      position: relative;
    }

    .bg {
      width: toVW(563);
      height: auto;
      margin: toVW(21) auto toVW(203);
    }

    .mainImg {
      background-position: center toVW(21);
      background-repeat: no-repeat;
      background-size:  auto;
      width: toVW(662);
      height: auto;
      margin: 0 auto;
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
    }

    .frame-outer {
      background-position: left top, left bottom, left top, right top;
      background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
      background-size: toVW(522) auto, toVW(522) auto, toVW(15) auto, toVW(15) auto;
      width: toVW(522);
      height: toVW(120);
      margin: 0 auto;
      position: relative;

      .inr {
        background-repeat: no-repeat;
        background-size: 2.8vw auto;
        background-position: 4.8vw center;
        width: 100%;
        height: 100%;
        padding: toVW(40);
        text-align: center;
        line-height: 1.5;
        letter-spacing: .07em;
      }

      .arrow {
        background-repeat: no-repeat;
        background-size: contain;
        width: toVW(21);
        height: toVW(28);
        position: absolute;
        top: calc((100% - 3.733vw) / 2);
        left: toVW(37);
      }
    }

    .shareTit {
      background: no-repeat center center;
      background-size: toVW(522) toVW(10);
      margin: toVW(-1) auto toVW(29);
      position: relative;
        text-align: center;

      p {
        font-size: toVW(26.5);
        padding: 0 .3em 0 .6em;
        display: inline;
      }
    }

    .sns {
      margin: 0 auto toVW(33);
      ul {
        display: flex;
        justify-content: center;

        li {
          width: toVW(73);
          margin-left: toVW(23);
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }

    .btn {
      div {
        &:first-of-type {
          margin-bottom: toVW(12);
        }
      }
    }
  }
</style>
